// @flow
import { isEmpty } from 'lodash';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';

type Link = { onClick?: () => void };

export const getLinkTagName = (link: ?Link) => {
  if (isEmpty(link)) {
    return 'div';
  }

  return link.onClick ? 'button' : DynamicLink;
};

export const getLinkProps = (link: ?Link) => (link?.onClick ? { ...link, type: 'button' } : link);
